<script lang="ts">
export default {
  name: 'DownloadButton',
};
</script>

<script setup lang="ts">
import AppButton from '@/components/v2/AppButton.vue';
import { Download } from 'lucide-vue-next';

const emit = defineEmits<{
  click: any;
}>();

withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);
</script>

<template>
  <app-button class="tw:rounded-md" :disabled="disabled" @click="emit('click')">
    <Download :size="16" class="hyperlink-icon tw:stroke-primary" />
  </app-button>
</template>
